import { createStyles, makeStyles } from '@mui/styles';

export const styles = makeStyles(() =>
  createStyles({
    button: {
      fontFamily: 'Sora',
    },
  }),
);
